// Hero background video runtime.
// The <video>/iframe is rendered inline by hero.liquid so the browser handles
// autoplay natively (iOS Safari won't reliably autoplay JS-inserted videos).
// This script's only job is to keep mobile WebKit/Chromium from overlaying its
// "Now Playing" prev/pause/next UI on top of the autoplaying hero — the
// browser claims navigator.mediaSession on every play event, so we clear it
// on load and on each play event of every hero video on the page.
(function () {
  if (!('mediaSession' in navigator)) return;

  function clearMediaSession() {
    try {
      ['play', 'pause', 'seekbackward', 'seekforward', 'previoustrack', 'nexttrack'].forEach(
        (action) => navigator.mediaSession.setActionHandler(action, null),
      );
      navigator.mediaSession.metadata = null;
      navigator.mediaSession.playbackState = 'none';
    } catch (e) {
      /* older browsers / non-supported actions — fine to ignore */
    }
  }

  clearMediaSession();
  document.querySelectorAll('.th-hero__video').forEach((video) => {
    ['loadeddata', 'play', 'playing'].forEach((evt) =>
      video.addEventListener(evt, clearMediaSession),
    );
  });
})();
